import { avatarDefault } from '@/assets/images';
import { Stack } from '@/components/layout';
import { Avatar, SvgIcon } from '@/components/ui';
import Text from '@/components/ui/text/text';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { useAvatarPicker } from '@/hooks/use-avatar-picker';
import { colors } from '@/theme/colors';
import { Controller, useFormContext } from 'react-hook-form';
import { TouchableOpacity } from 'react-native';

import type { MutateInfoAvatarForm } from './mutate-info-template';

export const MutateInfoAvatarSection = () => {
  const { control, setValue } = useFormContext<MutateInfoAvatarForm>();
  const { scale, isTablet } = useScaling();
  const styles = useStyles();
  const pickAvatar = useAvatarPicker();

  const handlePickAvatar = () => {
    pickAvatar(value => {
      setValue('avatar', value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    });
  };

  return (
    <Stack direction="row" align="center" gap={scale(10)}>
      <Controller
        name="avatar"
        control={control}
        render={({ field: { value }, fieldState: { error } }) => (
          <>
            <Avatar
              onPress={handlePickAvatar}
              size={scale(60)}
              borderColor={error ? colors.Error : 'transparent'}>
              <Avatar.Image source={value?.uri ?? avatarDefault} />
            </Avatar>
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.uploadContainer}
              onPress={handlePickAvatar}>
              <Stack gap={scale(2)}>
                <Stack direction="row" align="center" gap={scale(4)}>
                  <Text
                    variant={
                      isTablet ? 'Font Inter/Subtitle/Medium 12px' : 'Font Inter/Subtitle/Medium'
                    }
                    style={styles.uploadText}>
                    {STRINGS.player.mutatePlayer.profile.uploadPhoto}
                  </Text>
                  <SvgIcon
                    name="IcPaginationArrow"
                    size={scale(16)}
                    color={colors.Blue}
                    style={{ marginBottom: scale(2) }}
                  />
                </Stack>
                <Controller
                  name="avatar.fileSize"
                  control={control}
                  render={({ fieldState: { error: fileSizeError } }) => (
                    <Text
                      variant="Font Inter/Subtitle/Italic"
                      fontStyle="italic"
                      style={
                        fileSizeError?.message ? { color: colors.Error } : { color: colors['6'] }
                      }>
                      {fileSizeError?.message
                        ? fileSizeError?.message
                        : STRINGS.player.mutatePlayer.profile.uploadPhotoHint}
                    </Text>
                  )}
                />
              </Stack>
            </TouchableOpacity>
          </>
        )}
      />
    </Stack>
  );
};

const useStyles = createStyles(() => ({
  uploadContainer: {
    flex: 1,
  },
  uploadText: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  uploadHint: {
    color: colors['6'],
  },
  uploadArrow: {
    transform: [{ rotate: '180deg' }],
  },
}));
